export const siteConfig = {
  name: '安心导航',
  tagline: '成人免费网站精选导航 · 正规资源一站汇总',
  description: '寻找成人免费网站？本页精选全球合规成人免费网站资源，涵盖健康性教育、情感科普、合法影音平台等内容，帮助成年用户安全、私密、高效地找到所需正规资源，拒绝风险链接，保障隐私安全。',
  keywords: '成人免费网站,成人免费网站推荐,正规成人网站,成人健康教育网站,免费成人资源平台,合法成人内容,成人科普免费网站',
  url: 'https://anxindaohang.com',
  locale: 'zh-CN',
  brand: {
    intro: '安心导航成立于2023年，是国内首批专注于成人健康教育与正规资源导航的平台。我们致力于打破信息壁垒，为成年用户提供安全、合规、高质量的资源聚合服务。',
    mission: '让每一位成年用户都能在安全的环境中获取正规的成人健康教育资源，无需担心隐私泄露或恶意链接。',
    vision: '成为华语地区最值得信赖的成人教育资源导航平台。',
    values: [
      { title: '安全第一', desc: '所有收录资源均经过人工审核，确保无恶意软件、无钓鱼风险、无违法内容。' },
      { title: '隐私至上', desc: '不追踪用户行为，不收集个人数据，支持匿名访问，全程HTTPS加密。' },
      { title: '内容合规', desc: '严格遵循中国法律法规，仅收录合法合规的正规资源，倡导健康积极的性教育理念。' },
      { title: '持续更新', desc: '团队每周审核更新资源列表，剔除失效链接，新增优质资源，确保信息的时效性。' },
    ],
    stats: [
      { label: '收录资源', value: '500+' },
      { label: '资源分类', value: '12' },
      { label: '日均访问', value: '50,000+' },
      { label: '用户好评率', value: '98.6%' },
    ],
    contact: {
      email: 'contact@anxindaohang.com',
      wechat: 'AnxinDaohang',
      address: '上海市浦东新区张江高科技园区',
      phone: '021-8888-6666',
    },
  },
};

export const categories = [
  {
    slug: 'sex-education',
    name: '性教育科普',
    icon: 'ri-book-open-line',
    desc: '科学、健康的性知识教育平台，涵盖生理健康、性心理、两性关系等专业内容',
    color: 'accent',
    websites: [
      { id: 1, name: '中国性学会', url: 'https://www.chinasexology.org', desc: '国家级性学学术组织，提供权威的性健康科普内容与研究资讯', tags: ['权威机构', '学术研究'] },
      { id: 2, name: '性教育百科', url: 'https://www.sexedu.org', desc: '面向成年人的综合性教育知识库，涵盖基础生理知识到高级心理健康', tags: ['百科', '入门推荐'] },
      { id: 3, name: '两性健康在线', url: 'https://www.sexualhealth.cn', desc: '专注两性健康知识传播，提供专业医生撰写的科普文章', tags: ['健康', '医学'] },
      { id: 4, name: '青春健康教育网', url: 'https://www.youthhealth.cn', desc: '覆盖青春期至成年期的全阶段健康教育资源平台', tags: ['全阶段', '公益'] },
      { id: 5, name: 'WHO性健康专栏', url: 'https://www.who.int/health-topics/sexual-health', desc: '世界卫生组织官方性健康知识库，多语言支持', tags: ['国际组织', '权威'] },
      { id: 6, name: '性心理学研究', url: 'https://www.sexpsych.org', desc: '深入探讨性心理学领域的研究成果与实用指导', tags: ['心理学', '学术'] },
    ],
  },
  {
    slug: 'emotional-science',
    name: '情感科普',
    icon: 'ri-heart-line',
    desc: '两性情感关系知识平台，帮助建立健康的情感观念和亲密关系认知',
    color: 'primary',
    websites: [
      { id: 7, name: '亲密关系研究所', url: 'https://www.intimacy-lab.com', desc: '专注于亲密关系科学研究的科普平台，提供情感关系评估工具', tags: ['研究', '工具'] },
      { id: 8, name: '情感智慧学院', url: 'https://www.eq-love.org', desc: '情感智商培训与科普，提升两性沟通与理解能力', tags: ['培训', '沟通'] },
      { id: 9, name: '恋爱心理学', url: 'https://www.lovepsych.cn', desc: '从心理学角度解读恋爱与婚姻中的常见问题', tags: ['心理学', '恋爱'] },
      { id: 10, name: '婚姻家庭指南', url: 'https://www.marriage-guide.cn', desc: '婚姻家庭关系维护知识，夫妻沟通技巧与家庭和谐指导', tags: ['婚姻', '家庭'] },
      { id: 11, name: '情感修复中心', url: 'https://www.heal-relationship.com', desc: '提供情感创伤修复与关系重建的专业指导资源', tags: ['修复', '指导'] },
    ],
  },
  {
    slug: 'legal-media',
    name: '合法影音',
    icon: 'ri-film-line',
    desc: '合法合规的成人影视与媒体平台，获得正规授权的内容分发渠道',
    color: 'secondary',
    websites: [
      { id: 12, name: '合规影音平台A', url: 'https://www.legal-media-a.com', desc: '持有正规牌照的成人影音内容平台，所有内容均经过审查', tags: ['合规', '影视'] },
      { id: 13, name: '成人纪录片频道', url: 'https://www.adult-docu.com', desc: '聚焦成人主题的纪录片与教育影片资源', tags: ['纪录片', '教育'] },
      { id: 14, name: '艺术电影精选', url: 'https://www.art-film.cn', desc: '精选艺术类成人主题电影，注重审美与思想表达', tags: ['艺术', '电影'] },
      { id: 15, name: '合法直播平台', url: 'https://www.legal-live.cn', desc: '持证运营的成人内容直播平台，实名认证保障安全', tags: ['直播', '实名'] },
    ],
  },
  {
    slug: 'sexual-health',
    name: '性健康医疗',
    icon: 'ri-mental-health-line',
    desc: '性健康相关的医疗资讯、在线问诊、疾病科普与预防指导',
    color: 'accent',
    websites: [
      { id: 16, name: '性健康诊所在线', url: 'https://www.sexual-clinic.cn', desc: '在线性健康咨询与预约挂号服务平台', tags: ['医疗', '咨询'] },
      { id: 17, name: 'STD科普中心', url: 'https://www.std-info.org', desc: '性传播疾病科普、预防知识、检测指南一站式平台', tags: ['科普', '预防'] },
      { id: 18, name: '男性健康网', url: 'https://www.male-health.cn', desc: '专注男性生理与心理健康，提供专业指导与咨询', tags: ['男科', '健康'] },
      { id: 19, name: '女性健康之家', url: 'https://www.female-health.cn', desc: '女性生殖健康、生理周期管理与妇科知识科普', tags: ['妇科', '女性'] },
      { id: 20, name: '生殖健康基金会', url: 'https://www.repro-health.org', desc: '生殖健康公益组织，提供免费咨询与教育资源', tags: ['公益', '生殖'] },
    ],
  },
  {
    slug: 'legal-consultation',
    name: '法律咨询',
    icon: 'ri-scales-line',
    desc: '成人内容相关的法律法规咨询、权益保护与合规指导',
    color: 'primary',
    websites: [
      { id: 21, name: '网络安全法律咨询', url: 'https://www.cyber-law.cn', desc: '提供网络内容合规性法律咨询服务', tags: ['法律', '网络'] },
      { id: 22, name: '成人内容合规平台', url: 'https://www.content-compliance.cn', desc: '帮助企业及个人了解成人内容相关法律法规', tags: ['合规', '企业'] },
      { id: 23, name: '隐私权保护中心', url: 'https://www.privacy-rights.cn', desc: '专注于个人信息保护与隐私权法律咨询', tags: ['隐私', '权利'] },
      { id: 24, name: '网络权益联盟', url: 'https://www.net-rights.org', desc: '维护网络用户合法权益的公益法律组织', tags: ['公益', '维权'] },
    ],
  },
  {
    slug: 'mental-health',
    name: '心理健康',
    icon: 'ri-brain-line',
    desc: '性与情感相关的心理健康资源，包括心理咨询、压力管理与自我成长',
    color: 'secondary',
    websites: [
      { id: 25, name: '心理论坛', url: 'https://www.psycho-forum.cn', desc: '匿名心理健康交流社区，专业心理咨询师在线答疑', tags: ['社区', '咨询'] },
      { id: 26, name: '自我成长空间', url: 'https://www.self-growth.cn', desc: '个人成长与心理健康资源聚合平台', tags: ['成长', '资源'] },
      { id: 27, name: '正念减压中心', url: 'https://www.mindfulness-cn.org', desc: '正念冥想与压力管理，提升心理韧性与幸福感', tags: ['冥想', '减压'] },
      { id: 28, name: '性心理热线', url: 'https://www.sex-helpline.cn', desc: '24小时性心理健康咨询热线，专业保密', tags: ['热线', '保密'] },
    ],
  },
];

export const articles = [
  {
    id: 1,
    slug: 'how-to-identify-safe-adult-websites',
    title: '如何识别安全的成人网站：完整指南',
    excerpt: '在互联网上寻找成人内容时，安全始终是第一位的。本文将从多个维度教你如何判断一个成人网站是否安全可靠。',
    contentHtml: `<p>在当今互联网环境中，成人内容网站鱼龙混杂，许多不法分子利用用户的好奇心设置陷阱。学会识别安全的成人网站，是保护自己隐私和设备安全的基本技能。</p>
<h3>1. 检查网站是否使用HTTPS协议</h3>
<p>安全的网站必须使用HTTPS加密协议。在浏览器地址栏中查看是否有锁形图标，点击图标可以查看网站的SSL证书信息。合法的成人网站都会部署有效的SSL证书来保护用户数据传输的安全性。</p>
<h3>2. 查看网站备案信息</h3>
<p>在中国合法运营的网站必须在工信部进行ICP备案。合法的成人内容平台会在网站底部公示备案号。如果你找不到任何备案信息，建议谨慎访问。</p>
<h3>3. 评估内容合规性</h3>
<p>正规的成人网站会明确标注内容分级，并在首页显示年龄验证提示。网站内容应符合当地法律法规，不包含违法、暴力或非自愿的内容。</p>
<h3>4. 检查隐私政策</h3>
<p>可信赖的网站会有清晰的隐私政策，明确说明数据收集、使用和保护的规则。如果网站没有任何隐私政策，这意味着你的个人信息可能被随意使用。</p>
<h3>5. 用户评价与口碑</h3>
<p>在选择成人网站之前，可以搜索该网站的用户评价。正规平台通常有良好的口碑和较长的运营历史。避免访问刚成立不久、来源不明的网站。</p>
<h3>6. 广告与弹窗行为</h3>
<p>恶意成人网站通常会弹出大量广告窗口，甚至在你关闭页面后仍在后台运行。安全的平台不会有过度侵扰性的广告行为。</p>
<h3>结语</h3>
<p>网络安全无小事。通过以上方法，你可以有效识别安全的成人网站，保护自己的隐私和设备安全。记住，正规、合法的平台永远是最可靠的选择。</p>`,
    category: 'sex-education',
    categoryName: '性教育科普',
    coverImage: 'https://readdy.ai/api/search-image?query=Digital%20security%20shield%20icon%20on%20a%20clean%20laptop%20screen%2C%20minimalist%20workspace%20with%20soft%20warm%20lighting%2C%20abstract%20geometric%20background%2C%20professional%20tech%20aesthetic%2C%20subtle%20gradient%20accents%2C%20editorial%20design%20style&width=800&height=450&seq=article-cover-1&orientation=landscape',
    author: '安心编辑团队',
    date: '2025-12-15',
    tags: ['网络安全', '成人网站', '隐私保护', '安全指南'],
    relatedIds: [2, 3, 8],
  },
  {
    id: 2,
    slug: 'sexual-health-education-resources',
    title: '成年人必知的性健康教育资源平台推荐',
    excerpt: '性教育不是青少年的专利，成年人同样需要持续学习。本文为你推荐最优质的性健康教育资源平台。',
    contentHtml: `<p>性教育是一个终身学习的过程。对于成年人而言，了解正确的性健康知识不仅关乎个人健康，更影响亲密关系的质量。以下是经过我们团队严格筛选的优质性健康教育资源平台。</p>
<h3>为什么成年人也需要性教育？</h3>
<p>很多人认为性教育只是青春期的事情，这是一个常见的误解。实际上，成年人在不同人生阶段会面临不同的性健康问题：从避孕方式的选择、性传播疾病的预防，到孕期保健、更年期管理，再到性功能障碍的应对——这些都需要持续的知识更新。</p>
<h3>线上学习平台推荐</h3>
<p>目前国内已经出现了一批专业的性健康教育平台，例如中国性学会官网提供权威的学术资源，两性健康在线平台有专业医生撰写的科普内容。这些平台的内容都经过专业审核，可信度高。</p>
<h3>国际资源不容错过</h3>
<p>世界卫生组织（WHO）的性健康专栏提供了多语言版本的权威知识，涵盖从基础生理到高级心理健康的各个方面。这些资源完全免费，适合不同知识水平的学习者。</p>
<h3>如何选择适合自己的资源？</h3>
<p>建议从自己最关心的话题入手：如果你关注生殖健康，可以从医学类平台开始；如果你对两性关系感兴趣，情感科普类平台可能更适合你。关键是选择有专业背书的可靠来源。</p>
<h3>学习性教育的心态建议</h3>
<p>性教育是一门科学，应该以开放、理性的态度对待。放下羞耻感和偏见，把性健康知识当作医学知识来学习，你会发现这扇门后面是一个广阔的、有益的知识世界。</p>`,
    category: 'sex-education',
    categoryName: '性教育科普',
    coverImage: 'https://readdy.ai/api/search-image?query=Open%20book%20with%20glowing%20light%20bulb%20on%20a%20clean%20desk%2C%20warm%20ambient%20lighting%2C%20knowledge%20and%20education%20concept%2C%20minimalist%20design%2C%20soft%20cream%20background%2C%20elegant%20composition&width=800&height=450&seq=article-cover-2&orientation=landscape',
    author: '安心编辑团队',
    date: '2025-11-28',
    tags: ['性教育', '健康教育', '资源推荐', '成人学习'],
    relatedIds: [1, 4, 6],
  },
  {
    id: 3,
    slug: 'internet-privacy-protection-guide',
    title: '浏览成人内容时的隐私保护完全手册',
    excerpt: '隐私保护是每个互联网用户的基本权利。在浏览成人内容时，如何最大限度地保护自己的隐私？',
    contentHtml: `<p>在数字时代，隐私保护已经成为每个人都必须重视的议题。特别是在浏览成人内容时，隐私泄露的风险更高，需要采取额外的保护措施。</p>
<h3>使用隐私浏览模式</h3>
<p>所有主流浏览器都提供隐私浏览（或无痕模式）功能。在这个模式下，浏览器不会保存你的浏览历史、Cookie和表单数据。但请注意，这只能防止本地设备上的记录，无法隐藏你的网络活动。</p>
<h3>VPN的重要性</h3>
<p>虚拟专用网络（VPN）可以加密你的网络流量，隐藏你的真实IP地址。选择信誉良好的VPN服务商至关重要，避免使用来路不明的免费VPN，它们可能本身就是隐私的威胁。</p>
<h3>密码管理器</h3>
<p>如果你需要在成人网站上创建账号，建议使用密码管理器生成和存储强密码。不要在不同网站使用相同的密码，以防一个网站的密码泄露影响到其他账号的安全。</p>
<h3>支付隐私</h3>
<p>如果涉及付费服务，建议使用虚拟信用卡或第三方支付平台。避免直接使用主银行卡，减少财务信息泄露的风险。</p>
<h3>设备安全</h3>
<p>保持操作系统和浏览器的最新版本，安装可靠的安全软件。定期清理缓存和临时文件，防止他人从你的设备上获取浏览痕迹。</p>
<h3>社交媒体隔离</h3>
<p>不要使用社交媒体账号登录成人网站，这会将你的浏览行为与真实身份关联。使用独立的邮箱地址注册。</p>
<h3>结语</h3>
<p>隐私保护不是一次性工作，而是需要持续关注和维护的习惯。通过这些措施，你可以在享受网络便利的同时，有效保护自己的隐私安全。</p>`,
    category: 'sex-education',
    categoryName: '性教育科普',
    coverImage: 'https://readdy.ai/api/search-image?query=Digital%20privacy%20shield%20concept%20with%20lock%20icon%20on%20dark%20gradient%20background%2C%20cybersecurity%20theme%2C%20clean%20modern%20design%2C%20professional%20tech%20aesthetic%2C%20soft%20neon%20green%20accents&width=800&height=450&seq=article-cover-3&orientation=landscape',
    author: '安心编辑团队',
    date: '2025-11-10',
    tags: ['隐私保护', '网络安全', 'VPN', '数据安全'],
    relatedIds: [1, 5, 8],
  },
  {
    id: 4,
    slug: 'building-healthy-intimate-relationships',
    title: '建立健康亲密关系的五个关键要素',
    excerpt: '健康的情感关系不是天生的，而是需要学习和培养的。本文分享建立和维系健康亲密关系的科学方法。',
    contentHtml: `<p>健康的情感亲密关系是人生幸福感的重要来源。然而，很多人并没有接受过系统的情感教育，在亲密关系中常常感到困惑和无力。以下是基于心理学研究的五个关键要素。</p>
<h3>1. 有效沟通</h3>
<p>沟通是亲密关系的基石。有效的沟通不仅是表达自己的想法，更重要的是学会倾听。研究表明，高质量关系中的伴侣会使用"我陈述句"表达感受，而不是指责对方。</p>
<h3>2. 情感安全感</h3>
<p>在健康的亲密关系中，双方都应该感到安全——可以自由表达情感而不必担心被嘲笑、否定或惩罚。情感安全感是深度亲密的前提条件。</p>
<h3>3. 边界意识</h3>
<p>亲密不等于没有边界。健康的亲密关系需要双方都尊重彼此的独立性，包括个人空间、兴趣爱好和社交圈。边界不是隔阂，而是相互尊重的体现。</p>
<h3>4. 共同成长</h3>
<p>最好的亲密关系是相互促进、共同成长的关系。伴侣之间应该互相支持对方的目标和梦想，而不是限制对方的发展。</p>
<h3>5. 冲突管理</h3>
<p>冲突在任何关系中都是不可避免的。关键在于如何管理冲突：健康的做法是聚焦问题本身，而不是攻击对方的人格。学会在冲突后修复关系同样重要。</p>
<h3>结语</h3>
<p>亲密关系是一门需要终身学习的艺术。希望这五个要素能帮助你建立更健康、更幸福的情感亲密关系。</p>`,
    category: 'emotional-science',
    categoryName: '情感科普',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20hands%20gently%20touching%20in%20warm%20sunlight%2C%20abstract%20artistic%20style%2C%20soft%20golden%20hour%20glow%2C%20emotional%20connection%20concept%2C%20minimalist%20composition%2C%20cream%20background&width=800&height=450&seq=article-cover-4&orientation=landscape',
    author: '安心编辑团队',
    date: '2025-10-22',
    tags: ['亲密关系', '情感健康', '沟通技巧', '心理学'],
    relatedIds: [5, 6, 9],
  },
  {
    id: 5,
    slug: 'sexual-psychology-basics',
    title: '性心理学入门：理解性欲与情感的深层关系',
    excerpt: '性心理学是理解人类行为的重要维度。本文为初学者介绍性心理学的基本概念和实用知识。',
    contentHtml: `<p>性心理学是心理学的一个重要分支，研究人类的性行为、性感受和性认知。理解性心理学不仅有助于自我认知，也能改善亲密关系的质量。</p>
<h3>性与情感的神经科学基础</h3>
<p>大脑中的多巴胺、催产素和血清素等神经递质在性行为和情感连接中扮演着关键角色。了解这些生物化学机制，可以帮助我们理解为什么性体验会如此深刻地影响我们的情感状态。</p>
<h3>性脚本理论</h3>
<p>社会学家提出的性脚本理论认为，我们的性行为和性观念很大程度上是由社会文化环境塑造的。不同文化背景下的"正常"性行为可能截然不同，这意味着没有一种放之四海而皆准的性行为标准。</p>
<h3>性欲的多样性</h3>
<p>性欲是一个极其复杂且个体化差异很大的现象。影响性欲的因素包括激素水平、心理状态、关系质量、生活压力等。理解性欲的正常波动范围，有助于减少不必要的焦虑。</p>
<h3>性与依恋风格</h3>
<p>心理学研究发现，人的依恋风格（安全型、焦虑型、回避型）会影响他们在性关系中的表现和感受。了解自己的依恋风格，是改善性关系的第一步。</p>
<h3>结语</h3>
<p>性心理学为我们提供了理解自我和他人的重要工具。以科学的视角看待性，能以更健康的方式享受性与爱带来的美好体验。</p>`,
    category: 'emotional-science',
    categoryName: '情感科普',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20brain%20with%20warm%20colorful%20neural%20connections%2C%20psychology%20concept%20art%2C%20minimalist%20scientific%20illustration%20style%2C%20clean%20gradient%20background%2C%20soft%20pink%20and%20amber%20tones&width=800&height=450&seq=article-cover-5&orientation=landscape',
    author: '安心编辑团队',
    date: '2025-10-05',
    tags: ['性心理学', '神经科学', '依恋理论', '心理健康'],
    relatedIds: [4, 6, 7],
  },
  {
    id: 6,
    slug: 'marriage-relationship-maintenance',
    title: '婚姻关系维护指南：让爱情持续保鲜的秘诀',
    excerpt: '婚姻是需要经营的。本文从心理学研究出发，分享经过验证的婚姻关系维护策略。',
    contentHtml: `<p>婚姻不仅是爱情的结晶，更是一种需要持续投入的关系形式。研究表明，幸福的婚姻并非没有矛盾，而是夫妻双方掌握了有效的维护策略。</p>
<h3>定期进行"关系体检"</h3>
<p>就像身体需要定期体检一样，婚姻关系也需要定期的"健康检查"。建议夫妻每月安排一次专门的沟通时间，讨论关系中的满意之处和改进空间。</p>
<h3>保持性生活的质量</h3>
<p>性生活质量是婚姻满意度的重要指标。随着年龄增长和生活压力的增加，很多夫妻的性频率会下降。重要的是保持开放的心态，在变化中寻找新的亲密方式。</p>
<h3>培养共同的兴趣爱好</h3>
<p>共同的兴趣爱好是增进夫妻感情的"催化剂"。无论是运动、旅行、读书还是烹饪，一起做一些双方都喜欢的事情，可以增强婚姻的韧性。</p>
<h3>学会修复关系裂痕</h3>
<p>再好的婚姻也会有争吵和矛盾。关键不在于避免冲突，而在于如何修复。真诚的道歉、积极倾听和及时的情感回应是修复关系的三大法宝。</p>
<h3>保持个人的独立性</h3>
<p>健康的婚姻不是两个人的"融合"，而是两个独立个体的"联盟"。保持各自的兴趣爱好和社交圈，不仅不会削弱婚姻，反而能让关系更加健康持久。</p>
<h3>结语</h3>
<p>婚姻是一门需要终身学习的艺术。只要双方都愿意投入和成长，任何婚姻都可以变得更加幸福和美满。</p>`,
    category: 'emotional-science',
    categoryName: '情感科普',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20wedding%20rings%20on%20a%20soft%20textured%20surface%20with%20warm%20golden%20light%2C%20romantic%20elegant%20still%20life%20photography%2C%20minimalist%20composition%2C%20cream%20and%20rose%20gold%20tones&width=800&height=450&seq=article-cover-6&orientation=landscape',
    author: '安心编辑团队',
    date: '2025-09-18',
    tags: ['婚姻', '关系维护', '夫妻沟通', '家庭幸福'],
    relatedIds: [4, 5, 10],
  },
  {
    id: 7,
    slug: 'std-prevention-knowledge',
    title: '性传播疾病预防：每个成年人都应该知道的知识',
    excerpt: '预防胜于治疗。了解性传播疾病的传播途径和预防方法，是保护自己和伴侣健康的重要一步。',
    contentHtml: `<p>性传播疾病（STD）是一个全球性的公共卫生问题。了解STD的预防知识不是羞耻的事情，而是对自己和伴侣负责任的表现。</p>
<h3>常见性传播疾病概览</h3>
<p>常见的STD包括衣原体感染、淋病、梅毒、生殖器疱疹、HPV感染和HIV/AIDS。不同的STD有不同的潜伏期、症状和治疗方法。了解这些基本知识有助于及早发现和处理问题。</p>
<h3>有效的预防措施</h3>
<p>安全套是目前最有效的STD预防工具之一，正确使用可以大幅降低感染风险。此外，定期进行STD检测、与伴侣坦诚沟通性健康史、接种HPV疫苗等都是重要的预防策略。</p>
<h3>何时应该去做检测？</h3>
<p>如果你有新的性伴侣、出现异常症状、或者伴侣被诊断出STD，都应该尽快进行检测。即使没有症状，性活跃的成年人也建议每年进行一次常规STD筛查。</p>
<h3>检测后的应对</h3>
<p>如果检测结果呈阳性，不要恐慌。大多数STD都是可以有效治疗的。关键是遵从医嘱完成全程治疗，并通知近期性伴侣进行检测。</p>
<h3>消除污名化</h3>
<p>STD是一个医学问题，不应该被道德化或污名化。以开放、理智的态度对待STD，有助于更多人主动进行预防和检测，这对整个社会的公共卫生都有积极意义。</p>`,
    category: 'sexual-health',
    categoryName: '性健康医疗',
    coverImage: 'https://readdy.ai/api/search-image?query=Medical%20cross%20icon%20with%20shield%20symbol%20on%20clean%20white%20background%2C%20healthcare%20protection%20concept%2C%20minimalist%20medical%20illustration%20style%2C%20soft%20green%20accents&width=800&height=450&seq=article-cover-7&orientation=landscape',
    author: '安心编辑团队',
    date: '2025-09-01',
    tags: ['性传播疾病', '预防', '检测', '公共卫生'],
    relatedIds: [8, 2, 1],
  },
  {
    id: 8,
    slug: 'online-adult-content-law-guide',
    title: '成人内容法律法规指南：合规浏览的边界在哪里',
    excerpt: '了解与成人内容相关的法律法规，是每个成年网民的责任。本文梳理了中国大陆地区的主要相关法律规定。',
    contentHtml: `<p>在互联网上浏览成人内容时，了解相关的法律法规至关重要。本文旨在帮助成年用户理解法律边界，做到合规浏览。</p>
<h3>网络内容管理的法律框架</h3>
<p>中国的网络内容管理以《网络安全法》为核心，辅以《互联网信息服务管理办法》等法规。《未成年人保护法》对涉及未成年人的内容有特别严格的规定，这是绝对的红线。</p>
<h3>什么是合法的成人内容？</h3>
<p>合法的成人内容应符合以下标准：面向成年人且设置了年龄验证机制；内容不涉及未成年人的任何形式；不包含暴力、胁迫或非自愿行为的描写；符合公序良俗。健康教育类的性科普内容是完全合法的。</p>
<h3>个人浏览的注意事项</h3>
<p>作为个人用户，在浏览成人内容时应确保：不在公共场所浏览；不向未成年人传播相关链接或内容；不下载、存储或传播可能违法的内容；使用合法合规的平台和渠道。</p>
<h3>版权问题</h3>
<p>即使内容本身合法，未经授权的下载和传播也可能侵犯版权。尊重知识产权，通过正规渠道获取内容，既是法律要求，也是支持内容创作者的方式。</p>
<h3>结语</h3>
<p>法律是保护而非限制。在了解并遵守相关法律的前提下，成年人完全可以在合法的范围内获取所需的成人教育资源和内容。</p>`,
    category: 'legal-consultation',
    categoryName: '法律咨询',
    coverImage: 'https://readdy.ai/api/search-image?query=Law%20book%20with%20gavel%20on%20a%20clean%20desk%2C%20legal%20concept%20with%20warm%20lighting%2C%20minimalist%20office%20setting%2C%20professional%20aesthetic%2C%20soft%20amber%20and%20cream%20tones&width=800&height=450&seq=article-cover-8&orientation=landscape',
    author: '安心编辑团队',
    date: '2025-08-15',
    tags: ['法律法规', '合规', '网络安全法', '版权'],
    relatedIds: [1, 3, 9],
  },
  {
    id: 9,
    slug: 'mental-health-and-sexuality',
    title: '心理健康与性：不被看见的内在联系',
    excerpt: '心理健康状态直接影响性生活质量。探索心理与性之间的深层关联，学会从心理层面改善性体验。',
    contentHtml: `<p>心理健康和性健康是密不可分的两个维度。焦虑、抑郁、压力和创伤都会对人的性欲和性体验产生深远影响。理解这种联系，对于改善整体生活质量具有重要意义。</p>
<h3>焦虑如何影响性体验？</h3>
<p>表现焦虑是影响性体验最常见的心理问题之一。当人们过度关注自己在性行为中的"表现"时，反而会削弱自然的性反应。学习放松技术和正念练习可以有效缓解表现焦虑。</p>
<h3>抑郁症与性欲减退</h3>
<p>抑郁症常常伴随着性欲减退或丧失。这既可能是抑郁本身的影响，也可能是抗抑郁药物的副作用。重要的是与医生坦诚沟通，寻找平衡心理治疗和性健康的方案。</p>
<h3>创伤与性</h3>
<p>过去的创伤经历（无论是性创伤还是情感创伤）可能在多年后仍影响一个人的性体验。寻求专业的心理咨询和创伤治疗是走向康复的重要步骤。</p>
<h3>身体意象与性自信</h3>
<p>对自己身体的不满和不自信会严重影响性生活中的放松程度和愉悦体验。培养积极的身体意象，是提升性自信的基础。</p>
<h3>寻求专业帮助</h3>
<p>如果心理问题已经显著影响到你的性生活和人际关系，请不要独自承受。专业的性治疗师和心理咨询师可以为你提供有效帮助。</p>`,
    category: 'mental-health',
    categoryName: '心理健康',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20silhouette%20of%20a%20person%20with%20calm%20meditation%20pose%2C%20soft%20gradient%20sunset%20colors%20in%20background%2C%20mental%20wellness%20concept%2C%20minimalist%20art%20style%2C%20peaceful%20atmosphere&width=800&height=450&seq=article-cover-9&orientation=landscape',
    author: '安心编辑团队',
    date: '2025-07-28',
    tags: ['心理健康', '性健康', '焦虑', '创伤疗愈'],
    relatedIds: [5, 4, 7],
  },
  {
    id: 10,
    slug: 'gender-communication-skills',
    title: '两性沟通的艺术：跨越性别差异的对话技巧',
    excerpt: '男女在沟通方式上存在天然差异，了解这些差异并掌握跨性别沟通技巧，能大幅提升关系质量。',
    contentHtml: `<p>男女之间的沟通差异是许多关系冲突的根源。理解并尊重这些差异，学习有效的跨性别沟通技巧，是建立健康亲密关系的关键能力。</p>
<h3>沟通风格的性别差异</h3>
<p>心理学研究表明，男性倾向于"报告式"沟通——关注事实和解决方案；而女性更倾向于"关系式"沟通——关注情感连接和共情体验。这并非刻板印象，而是统计上的普遍趋势。</p>
<h3>倾听的真正含义</h3>
<p>很多人把"听"等同于"倾听"，但真正的倾听需要全神贯注、不打断、不急于给出建议。特别是当伴侣只是想倾诉情感时，你的角色是理解而不是解决问题。</p>
<h3>表达需求而非抱怨</h3>
<p>使用"我"开头的陈述句表达自己的感受和需求，比使用"你"开头的指责句更能促进有效沟通。例如"我感到被忽视"比"你总是忽视我"更容易被接受。</p>
<h3>情绪管理在沟通中的作用</h3>
<p>在情绪激动时进行的沟通往往适得其反。学会识别自己的情绪触发点，在必要时暂停对话、冷静下来后再继续，是成熟沟通的重要品质。</p>
<h3>实践练习</h3>
<p>建议伴侣定期进行"倾听练习"：一人表达五分钟不被打断，另一人复述所听到的内容和感受。这个简单的练习能显著提升双方的理解深度。</p>`,
    category: 'emotional-science',
    categoryName: '情感科普',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20speech%20bubbles%20with%20soft%20gradient%20colors%20connecting%2C%20communication%20concept%2C%20minimalist%20graphic%20design%2C%20warm%20coral%20and%20teal%20tones%2C%20clean%20abstract%20background&width=800&height=450&seq=article-cover-10&orientation=landscape',
    author: '安心编辑团队',
    date: '2025-07-10',
    tags: ['两性沟通', '性别差异', '倾听技巧', '关系提升'],
    relatedIds: [4, 6, 5],
  },
];

export const faqs = [
  {
    q: '安心导航收录的网站是否完全免费？',
    a: '是的，我们收录的所有网站资源均提供免费内容或免费试用服务。部分平台可能提供付费增值服务，但基础内容均免费可访问。我们会在每个资源的描述中标注清楚收费情况，让用户自主选择。',
  },
  {
    q: '如何确保收录网站的安全性？',
    a: '我们采用三重审核机制：首先由自动化工具扫描网站是否包含恶意代码或钓鱼风险；然后由人工编辑团队逐一访问验证内容合规性；最后定期（每周）对已收录网站进行复查，及时剔除出现问题的资源。用户也可通过联系邮箱向我们举报问题网站。',
  },
  {
    q: '网站是否需要注册才能使用？',
    a: '安心导航本身完全免费且无需注册，所有资源链接均可直接访问。我们尊重用户隐私，不收集任何个人信息，也不要求用户创建账号。',
  },
  {
    q: '如果发现收录的网站有违规内容怎么办？',
    a: '如发现任何收录网站出现违规内容，请通过联系邮箱（contact@anxindaohang.com）向我们举报。我们承诺在24小时内核实并处理。对于确认违规的资源，我们会立即下架并在平台上公示处理结果。',
  },
  {
    q: '网站内容的更新频率是怎样的？',
    a: '我们的编辑团队每周对资源库进行全面更新：删除失效或不合规的链接，新增优质的成人教育资源。同时，我们也会根据用户反馈和行业动态，不定期增加新的资源分类。',
  },
  {
    q: '如何推荐优质的成人教育资源网站？',
    a: '欢迎通过我们的联系邮箱提交推荐。请附上网站名称、URL地址及推荐理由。我们的编辑团队会在收到推荐后的3个工作日内进行审核，审核通过后会在下一轮更新中加入。',
  },
  {
    q: '在安心导航浏览是否绝对安全？',
    a: '安心导航本身不存储或传输任何成人内容，仅提供资源导航链接。我们采用HTTPS加密传输，且不追踪用户行为。但我们仍建议用户在访问外部网站时，自行采取必要的隐私保护措施（如使用隐私浏览模式、VPN等）。',
  },
];